import React, { FC, useEffect } from 'react';
import { useAuthManager, useFeatureFlags } from '@funtech-int/yango-shared';

import { getRequestId } from '@kinopoisk-int/request-ids';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { useLogger } from '@/shared/hooks/useLogger';
import { BughunterExtraData, initBughunter, updateBughunterData } from '@/app/lib/bughunter';
import { clientConfig } from '@/config/client';

const { appVersion, environment } = clientConfig;
const version = `${environment}/${appVersion}`;

const getTraceId = (traceparent: string) => (traceparent ? traceparent.split('-')[1] : undefined);

let bughunterInited = false;

interface BughunterProps extends BughunterExtraData {}

const Bughunter: FC<BughunterProps> = (props) => {
    const {
        version,
        yandexuid,
        profileId,
        puid,
        email,
        experimentIds,
        requestId,
        traceId = '',
    } = props;

    const logger = useLogger();

    useEffect(() => {
        if (bughunterInited) {
            return;
        }

        initBughunter(logger);
        bughunterInited = true;
    }, [logger]);

    useEffect(() => {
        updateBughunterData(
            {
                version,
                yandexuid,
                profileId,
                puid,
                email,
                experimentIds,
                requestId,
                traceId: traceId
                    ? `https://m.yandex-team.ru/projects/kpfrontendapplications/traces/${traceId}`
                    : '',
            },
            { logger }
        );
    }, [version, profileId, puid, email, experimentIds, yandexuid, requestId, traceId, logger]);

    return null;
};

export const BughunterContainer: FC = () => {
    const profileManager = useProfileManager();
    const authManager = useAuthManager();

    const { testIds: experimentIds } = useFeatureFlags();

    const requestId: string = getRequestId(window.Ya?._reqId);
    const traceparent: string = window.Ya?._traceparent || '';

    const isProduction = environment === 'production';
    const isNeedToUseBughunter = !isProduction || profileManager.isInternal();

    return isNeedToUseBughunter ? (
        <Bughunter
            yandexuid={authManager.yandexuid}
            requestId={requestId}
            traceId={getTraceId(traceparent)}
            profileId={profileManager.userProfile?.ottId ?? undefined}
            experimentIds={experimentIds}
            puid={String(profileManager.userProfile?.puid ?? '')}
            email={profileManager.userProfile?.passportEmail ?? ''}
            version={version}
        />
    ) : null;
};
